// @snippet
/**
 * @class Notification
 */
// import Picture from "../apps-react/global/Picture/Picture";

const handle = document.querySelector('#gld-notification');
const handle_close = handle
  ? handle.querySelector('.gld-notification__close')
  : null;
const handle_text = handle
  ? handle.querySelector('.gld-notification__text')
  : null;
let notification_time_default = 5; //seconds
const notification_time_error = 15; //seconds
class Notification {
  static actionResolve = null;

  // constructor() {
  //     console.log('const Notification')
  //     // this.remove = this.remove.bind(this)
  // }

  static async mark(state, data, options = {}) {
    // Notification.clearNotification()
    if (!window.notification_assets_css) {
      await Notification.loadCSS();
    }

    if (handle) {
      const variant = options?.variant || 'standard';
      if (variant) {
        handle.classList.add(`gld-notification--${variant}`);
      }
      handle.dataset.state = state;
      const html = Array.isArray(data)
        ? Notification.renderNotificationList(data)
        : data;
      const actions = Array.isArray(options?.actions) ? options.actions : [];
      const normalizedActions = Notification.normalizeActions(actions);
      let theme = 'default';
      let notification_time = notification_time_default;
      if (options?.theme) {
        theme = options.theme;
      }
      if (options?.notification_time !== undefined) {
        notification_time = options.notification_time;
      }

      if (theme === 2) {
        handle.classList.add(`gld-notification--theme--${theme}`);
      }
      handle.style.removeProperty('display');
      handle.classList.add(`animated`);
      handle.classList.add(`fadeInUp`);
      handle.querySelector('.gld-notification__icons').style.display =
        options?.icon === false ? 'none' : 'block';
      //   handle.querySelector('.gld-notification__close').style.display =
      //     options?.close === false ? 'none' : 'block';

      if (options?.close || notification_time === false) {
        handle_close.classList.add('active');
      }

      if (options?.styles) {
        Object.keys(options.styles).forEach((key) => {
          handle.style[key] = options.styles[key];
        });
      }
      Notification.clearActionResolver();
      if (handle_text) {
        handle_text.innerHTML = `${html}${Notification.renderActions(normalizedActions)}`;
      }

      if (normalizedActions.length && handle_text) {
        handle_text
          .querySelectorAll('[data-notification-action-index]')
          .forEach((btn) => {
            btn.addEventListener('click', async (e) => {
              const target = e.currentTarget;
              const actionIndex = Number(
                target.getAttribute('data-notification-action-index')
              );
              const action = normalizedActions[actionIndex];
              target.classList.add('gld-btn--loading');
              if (typeof action?.function === 'function') {
                try {
                  await action.function();
                } catch (err) {
                  console.error('Notification action function error', err);
                }
              }
              const actionName =
                action?.name || target.getAttribute('data-notification-action');
              Notification.remove(actionName);
            });
          });
      }

      handle.classList.add(`gld-notification--active`);
      if (notification_time) {
        setTimeout(
          () => Notification.remove('timeout'),
          (state === 'error' ? notification_time_error : notification_time) *
            1000
        );
      }

      if (normalizedActions.length) {
        return new Promise((resolve) => {
          Notification.actionResolve = resolve;
        });
      }

      return null;
    }

    return null;
  }

  static renderNotificationList(data = []) {
    if (!Array.isArray(data) || !data.length) {
      return '';
    }

    const list = data
      .filter((item) => item !== undefined && item !== null && item !== '')
      .map(
        (item) =>
          `<li class="gld-notification__list__item">${Notification.renderNotificationListItem(item)}</li>`
      )
      .join('');

    return list ? `<ul class="gld-notification__list">${list}</ul>` : '';
  }

  static renderNotificationListItem(item) {
    if (typeof item === 'string') {
      return item;
    }

    const wrapper = document.createElement('div');
    wrapper.classList.add('gld-notification__list__item__data');

    const title = item?.title || '';
    if (title) {
      const titleEl = document.createElement('strong');
      titleEl.classList.add('gld-notification__list__item__title');
      titleEl.textContent = title;
      wrapper.appendChild(titleEl);
    }

    const message = item?.message || item?.text || '';
    if (message) {
      const messageEl = document.createElement('p');
      messageEl.classList.add('gld-notification__list__item__message');
      messageEl.textContent = message;
      wrapper.appendChild(messageEl);
    }

    if (item?.details) {
      const detailsEl = document.createElement('p');
      detailsEl.classList.add('gld-notification__list__item__details');
      detailsEl.innerHTML = `<strong>Details:</strong> ${item.details}`;
      wrapper.appendChild(detailsEl);
    }

    return wrapper.innerHTML;

    if (reason && title && message) {
      return `<strong>${title}</strong> ${message}. Reason: <strong>${reason}</strong>`;
    }
    if (title && message) {
      return `<strong>${title}</strong>: ${message}`;
    }
    if (title) {
      return `<strong>${title}</strong>`;
    }

    return message || '';
  }

  static remove(actionName = null) {
    Notification.resolveAction(actionName);
    if (handle && handle.classList.contains('gld-notification--active')) {
      handle.classList.add(`fadeOutDown`);
      handle.classList.remove(`fadeInUp`);
      if (handle.classList.contains('gld-notification--theme--2')) {
        setTimeout(() => {
          if (handle_text) {
            handle_text.innerHTML = '';
          }
          handle.classList.remove(`gld-notification--theme--2`);
          handle.classList.remove(`fadeOutDown`);
          handle.removeAttribute('data-state');
          handle.classList.remove(`gld-notification--active`);
          handle.classList.remove(`animated`);
        }, 300);
      } else {
        setTimeout(() => {
          handle.classList.remove(`animated`);
          handle.classList.remove(`fadeOutDown`);
          if (handle_text) {
            handle_text.innerHTML = '';
          }
          handle.removeAttribute('data-state');
          handle.classList.remove(`gld-notification--active`);
        }, 300);
      }
    }
  }

  static async loadCSS() {
    const path = 'parts/notification';
    await import(
      /* webpackChunkName: "[request]"*/ `../../sass2/chunks/${path}.scss`
    );
    window.notification_assets_css = true;
  }

  static clearNotification() {
    Notification.clearActionResolver();
    if (handle && handle.classList.contains('gld-notification--active')) {
      if (handle_text) {
        handle_text.innerHTML = '';
      }
      handle.removeAttribute('data-state');
      handle.classList.remove(`gld-notification--active`);
    }
  }

  static resolveAction(actionName = null) {
    if (Notification.actionResolve) {
      Notification.actionResolve(actionName);
      Notification.actionResolve = null;
    }
  }

  static clearActionResolver() {
    if (Notification.actionResolve) {
      Notification.actionResolve(null);
      Notification.actionResolve = null;
    }
  }

  static renderActions(actions = []) {
    if (!actions.length) {
      return '';
    }

    const html = actions
      .filter((action) => action?.name && action?.label)
      .map((action, index) => {
        return `<button type="button" class="gld-notification__action gld-btn--gold gld-btn--small gld-btn--strong" data-notification-action="${action.name}" data-notification-action-index="${index}"><span class="gld-btn__text">${action.label}</span></button>`;
      })
      .join('');

    return html ? `<div class="gld-notification__actions">${html}</div>` : '';
  }

  static normalizeActions(actions = []) {
    return actions
      .map((action) => {
        const actionName = action?.name || action?.action;
        if (!actionName || !action?.label) {
          return null;
        }
        return {
          ...action,
          name: actionName,
        };
      })
      .filter(Boolean);
  }

  // static renderTheme2(data) {
  //     const html = `
  //         <div class="gld-notification__text__image">
  //             <img src="${data.image.url}" alt=${data.image.alt} />
  //         </div>
  //         <div class="gld-notification__text__data">
  //             <div class="gld-notification__text__data__title">${data.title}</div>
  //             <div class="gld-notification__text__data__subtitle">${data.subtitle}</div>
  //         </div>
  //     `
  //     return html;
  // }
}

if (handle_close) {
  handle_close.addEventListener('click', () => Notification.remove());
}
export default Notification;
